export type NodeKind = 'hire' | 'partner' | 'coaching' | 'auditing'

export interface FlowNode {
  label: string
  kind: NodeKind
}

export interface FlowStage {
  label: string
  owner: 'hire' | 'partner' | 'retention'
  above: FlowNode[]
  below: FlowNode[]
}

const hire = (label: string): FlowNode => ({ label, kind: 'hire' })
const partner = (label: string): FlowNode => ({ label, kind: 'partner' })
const coaching = (label: string): FlowNode => ({ label, kind: 'coaching' })
const auditing = (label: string): FlowNode => ({ label, kind: 'auditing' })

export const systemStages: FlowStage[] = [
  {
    label: 'Job Boards',
    owner: 'hire',
    above: [
      hire('Account management'),
      hire('Ad management'),
      hire('Ad copy and creative'),
      hire('Split testing'),
      hire('KPI tracking'),
      hire('Budget management'),
      hire('$250k/mo ad spend intelligence'),
    ],
    below: [],
  },
  {
    label: 'Applicant Tracking System',
    owner: 'hire',
    above: [hire('ATS build'), hire('Resume filtering'), hire('Auto-responders')],
    below: [
      hire('Pipeline stages'),
      hire('Workflow automations'),
      hire('Dashboards and reporting'),
      partner('Hiring manager access'),
    ],
  },
  {
    label: 'Prospect Tracking System',
    owner: 'hire',
    above: [
      hire('PTS build'),
      hire('Video and audio responses'),
      hire('Prospect scoring'),
      partner('Live pipeline visibility'),
    ],
    below: [],
  },
  {
    label: 'Pre-Screening',
    owner: 'hire',
    above: [hire('Screening questions'), hire('Text verification')],
    below: [],
  },
  {
    label: 'Screening Call',
    owner: 'hire',
    above: [],
    below: [
      hire('Call framework'),
      hire('Qualification'),
      hire('Objection handling'),
      hire('Interview booked'),
    ],
  },
  {
    label: 'Interview and Hiring',
    owner: 'partner',
    above: [
      partner('Scripts'),
      partner('Interview'),
      partner('Questions'),
      partner('Commitment'),
      partner('Hiring moment'),
      auditing('HIRE auditing'),
      coaching('HIRE coaching'),
    ],
    below: [],
  },
  {
    label: 'Onboarding',
    owner: 'partner',
    above: [],
    below: [
      hire('Onboarding form'),
      hire('Welcome email'),
      partner('Script'),
      partner('Expectations video'),
      partner('Meeting with manager'),
    ],
  },
  {
    label: 'Integration',
    owner: 'partner',
    above: [],
    below: [
      partner('Hire day'),
      partner('Next-day check'),
      partner('First week check'),
      auditing('HIRE auditing'),
      coaching('HIRE coaching'),
    ],
  },
  {
    label: 'Sales School',
    owner: 'hire',
    above: [
      hire('Weekend homework'),
      hire('Day 1 live intensive'),
      hire('Day 2 live intensive'),
      hire('Recorded sessions'),
      partner('The Forge app'),
    ],
    below: [],
  },
  {
    label: 'Day 3–7',
    owner: 'partner',
    above: [],
    below: [
      partner('Shadowing'),
      partner('Knocking'),
      partner('Personal conferences'),
      coaching('HIRE coaching'),
    ],
  },
  {
    label: 'Retention',
    owner: 'retention',
    above: [],
    below: [],
  },
]

export const systemLegend: Array<{ label: string; kind: NodeKind }> = [
  { label: 'HIRE', kind: 'hire' },
  { label: 'HIRE Coaching', kind: 'coaching' },
  { label: 'HIRE Auditing', kind: 'auditing' },
  { label: 'Partner', kind: 'partner' },
]
